import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${p => (p.column ? 'column' : 'row')};
  align-items: center;
  justify-content: ${p => (p.justifyCenter ? 'center' : 'space-between')};
  width: 100%;
  max-width: 1340px;
  margin: ${p => (p.margin ? p.margin : '0 auto')};
  padding: 20px;
  height: 100%;

  @media (min-width: 768px) {
    padding: ${p => (p.distance ? 'var(--border-distance)' : '0')};
  }
`;

export const Title = styled.h5`
  letter-spacing: 0.6px;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 24px;
  line-height: 32px;
  color: #212121;
  font-weight: 600;
  text-align: right;
  max-width: 480px;
`;

export const Section = styled.section`
  width: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
  height: 500px;
  background: ${p => p.bgcolor};

  @media (min-width: 768px) {
    padding-top: 20px;
    height: 600px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  width: 100%;
  height: 440px;

  @media (min-width: 768px) {
    height: 400px;
  }
`;
